import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { meetingsAPI } from '../services/api';
import './Meetings.css';

const Meetings = () => {
  const [meetings, setMeetings] = useState([]);
  const [filter, setFilter] = useState('all');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    loadMeetings();
  }, [filter]);

  const loadMeetings = async () => {
    setLoading(true);
    try {
      const response = await meetingsAPI.getAll(filter);

      console.log("API response:", response.data);

      setMeetings(response.data.data || []);

    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };
  const handleDeleteMeeting = async (meetingId) => {
    if (!window.confirm('Are you sure you want to cancel this meeting?')) return;
    
    try {
      await meetingsAPI.deleteMeeting(meetingId);
      loadMeetings();
    } catch (err) {
      setError(err.message);
    }
  };

  const getStatusBadge = (meeting) => {
    if (meeting.status === 'cancelled') {
      return <span className="status-badge cancelled">Cancelled</span>;
    }
    if (meeting.status === 'completed') {
      return <span className="status-badge completed">Completed</span>;
    }
    if (meeting.status === 'in-progress') {
      return <span className="status-badge in-progress">In Progress</span>;
    }
    
    // Check if scheduled time has passed
    const now = new Date();
    const start = new Date(meeting.scheduledStart);
    const end = new Date(start.getTime() + meeting.duration * 60000);
    
    if (now >= start && now < end) {
      return <span className="status-badge in-progress">Starting</span>;
    }
    
    return <span className="status-badge scheduled">Scheduled</span>;
  };

  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    return {
      date: date.toLocaleDateString(),
      time: date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    };
  };

  if (!user) {
    return <div className="meetings-loading">Please log in to view your meetings.</div>;
  }

  return (
    <div className="meetings-page">
      <div className="meetings-header">
        <div>
          <h1>Mes réunions</h1>
          <p>Consultez et gérez vos réunions programmées</p>
        </div>
        <Link to="/schedule" className="btn-primary">
          Planifier une réunion
        </Link>
      </div>

      {error && <div className="error-message">{error}</div>}

      <div className="meetings-filters">
        <button 
          className={`filter-btn ${filter === 'all' ? 'active' : ''}`}
          onClick={() => setFilter('all')}
        >
          All
        </button>
        <button 
          className={`filter-btn ${filter === 'upcoming' ? 'active' : ''}`}
          onClick={() => setFilter('upcoming')}
        >
          Upcoming
        </button>
        <button 
          className={`filter-btn ${filter === 'host' ? 'active' : ''}`}
          onClick={() => setFilter('host')}
        >
          My Meetings
        </button>
        <button 
          className={`filter-btn ${filter === 'invited' ? 'active' : ''}`}
          onClick={() => setFilter('invited')}
        >
          Invited
        </button>
      </div>

      <div className="meetings-content">
        {loading ? (
          <div className="meetings-loading">Chargement des réunions...</div>
        ) : meetings.length === 0 ? (
          <div className="no-meetings">
            <p>Aucune réunion trouvée</p>
            <Link to="/schedule" className="btn-secondary">
              Planifier une réunion
            </Link>
          </div>
        ) : (
          <div className="meetings-list">
            {meetings.map(meeting => {
              const { date, time } = formatDateTime(meeting.scheduledStart);
              const isHost = meeting.hostId === user.id;
              
              return (
                <div key={meeting.id} className="meeting-card">
                  <div className="meeting-info">
                    <div className="meeting-date-time">
                      <span className="meeting-date">{date}</span>
                      <span className="meeting-time">{time}</span>
                    </div>
                    <div className="meeting-details">
                      <h3>{meeting.title}</h3>
                      {meeting.description && (
                        <p className="meeting-description">{meeting.description}</p>
                      )}
                      <div className="meeting-meta">
                        <span>Duration: {meeting.duration} min</span>
                        {isHost && <span className="host-badge">Hote</span>}
                      </div>
                    </div>
                  </div>
                  <div className="meeting-actions">
                    {getStatusBadge(meeting)}
                    {meeting.roomId && meeting.status !== 'cancelled' && (
                      <Link 
                        to={`/room/${meeting.roomId}`}
                        className="btn-join"
                      >
                        Join
                      </Link>
                    )}
                    {isHost && meeting.status === 'scheduled' && (
                      <button 
                        className="btn-cancel"
                        onClick={() => handleDeleteMeeting(meeting.id)}
                      >
                        Cancel
                      </button>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default Meetings;
